import { StrictMode, type ComponentType } from 'react';
import { createRoot } from 'react-dom/client';
import { BootError } from './app/boot-error';
import { AppProviders } from './app/providers';
import { createQueryClient } from './app/query-client';
import { loadRuntimeConfig } from './app/runtime-config';
import { applyBrand } from './app/theme/brand-theme';
import './index.css';

/** VITE_MOCKS=1: answer /api from MSW in this browser. Returns the badge that says so. */
async function startMocks(): Promise<ComponentType | null> {
  if (import.meta.env.VITE_MOCKS !== '1') return null;
  const [{ startMockWorker }, { MockDataBadge }] = await Promise.all([
    import('./mocks/browser'),
    import('./mocks/mock-data-badge'),
  ]);
  await startMockWorker();
  return MockDataBadge;
}

async function boot() {
  const el = document.getElementById('root');
  if (!el) throw new Error('index.html is missing #root');
  const root = createRoot(el);
  try {
    const MockBadge = await startMocks();
    const config = await loadRuntimeConfig();
    applyBrand(config.presentation);
    root.render(
      <StrictMode>
        <AppProviders config={config} queryClient={createQueryClient()} />
        {MockBadge && <MockBadge />}
      </StrictMode>,
    );
  } catch (error) {
    root.render(<BootError error={error} />);
  }
}

void boot();
